import React, { useEffect } from "react";
import "../../styles/IdentitySplit.css";

export default function IdentitySplit() {
  useEffect(() => {
    const reveals = document.querySelectorAll(".reveal");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 1 }
    );

    reveals.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="identity-split">
      <div className="identity-left reveal">
        <h2>Why Javelynx?</h2>
        <p className="muted">Our name blends two powerful symbols:</p>
        <ul>
          <li>
            <span>Javelin</span> — speed, precision, and direct impact.
          </li>
          <li>
            <span>Lynx</span> — agility, intelligence, and sharp vision.
          </li>
        </ul>
        <p className="muted">
          Together, Javelynx stands for building solutions that are fast,
          accurate, and adaptive—always on target, always ahead.
        </p>
      </div>

      <div className="identity-right reveal">
        <div className="grid">
          <div className="card reveal">
            <h3>Clarity</h3>
            <p>Simple plans, visible progress.</p>
          </div>
          <div className="card reveal">
            <h3>Ownership</h3>
            <p>We treat your product like ours.</p>
          </div>
          <div className="card reveal">
            <h3>Security</h3>
            <p>Privacy &amp; least-privilege by design.</p>
          </div>
          <div className="card reveal">
            <h3>Transparency</h3>
            <p>Scope, budget, risks—no surprises.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
